import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#if @containerless~}}\n  <LiquidVersions\n    @value={{@value}}\n    @use={{@use}}\n    @rules={{@rules}}\n    @matchContext={{this.forwardMatchContext}}\n    @versionEquality={{@versionEquality}}\n    @renderWhenFalse={{true}}\n    @containerElement={{@containerElement}}\n    @class={{@class}} as |version|\n  >\n    {{~#if (has-block)}}\n      {{~yield version~}}\n    {{else}}\n      {{~version~}}\n    {{/if~}}\n  </LiquidVersions>\n{{~else~}}\n  <LiquidContainer\n    id={{@containerId}}\n    class={{@class}}\n    @growDuration={{@growDuration}}\n    @growPixelsPerSecond={{@growPixelsPerSecond}}\n    @growEasing={{@growEasing}}\n    @shrinkDelay={{@shrinkDelay}}\n    @growDelay={{@growDelay}}\n    @enableGrowth={{@enableGrowth}}\n  as |container|>\n    {{~!~}}\n    <LiquidVersions\n      @value={{@value}}\n      @notify={{container}}\n      @use={{@use}}\n      @rules={{@rules}}\n      @containerElement={{container.element}}\n      @matchContext={{this.forwardMatchContext}}\n      @versionEquality={{@versionEquality}}\n      @renderWhenFalse={{true}} as |version| \n    >\n      {{~#if (has-block)}}\n        {{~yield version~}}\n      {{else}}\n        {{~version~}}\n      {{/if~}}\n    </LiquidVersions>\n    {{~!~}}\n  </LiquidContainer>\n{{~/if}}");

class LiquidBindComponent extends Component {
  get forwardMatchContext() {
    let m = this.args.matchContext;
    if (!m) {
      m = {};
    }
    if (!m.helperName) {
      m.helperName = 'liquid-bind';
    }
    return m;
  }
}
setComponentTemplate(TEMPLATE, LiquidBindComponent);

export { LiquidBindComponent as default };
//# sourceMappingURL=liquid-bind.js.map
